/**
 * Deprecated hardcoded colors — do not use in new code.
 * These preserve the original hex values that have no exact match in paletteColors.
 * Each should eventually be replaced by a proper design token.
 */

/* eslint-disable no-restricted-syntax */
export const deprecated_FFB200 = '#FFB200';
export const deprecated_353C43 = '#353C43';
export const deprecated_868E96 = '#868E96';
export const deprecated_CCFF90 = '#CCFF90';
export const deprecated_00E676 = '#00E676';
export const deprecated_00C853 = '#00C853';
export const deprecated_000000 = '#000000';
export const deprecated_BEDCC8 = '#BEDCC8';
/* eslint-enable no-restricted-syntax */
